type Props = {
  label?: string
  name: string
  error?: boolean
}

const Textarea = ({label, name, error}: Props) => (
  <textarea
    name={name}
    placeholder={label}
    rows={5}
    className={`w-full appearance-none rounded-none border-b-[0.5px] py-3 outline-none text-headline-sm placeholder:text-black placeholder-shown:border-black-low focus:!outline-none focus-visible:!outline-none ${error ? '!border-red' : 'border-black'}`}
  />
)

export default Textarea
